import { render, staticRenderFns } from "./AdvertiseManage.vue?vue&type=template&id=33992574&scoped=true"
import script from "./AdvertiseManage.vue?vue&type=script&lang=js"
export * from "./AdvertiseManage.vue?vue&type=script&lang=js"
import style0 from "./AdvertiseManage.vue?vue&type=style&index=0&id=33992574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33992574",
  null
  
)

export default component.exports